import { deriveTitleAndUnitsFromColumnNames } from "components/athena/CsvColumnNameParsing";
import { groupByFunc } from "extensions/groupBy";

import {
  getHighchartOptions,
  HighchartDataBySeries,
  HighchartPlotline,
} from "./HighchartOptions";

export const getHighchartOptionsForCsv = (
  {
    parsedRows,
    columns,
    plotLines,
  }: {
    parsedRows: number[][];
    columns: { name: string; index: number }[];
    plotLines?: HighchartPlotline[];
  },
  onComplete?: () => void
) => {
  const columnsExcludingTimestamp = columns.slice(1);
  const {
    title: derivedTitle,
    columnDefinitions,
  } = deriveTitleAndUnitsFromColumnNames(
    columnsExcludingTimestamp.map((x) => x.name)
  );
  const {
    yAxis,
    columnDefinitionsWithAxisIndex,
  } = deriveAxisFromColumnDefinitions(columnDefinitions);
  const dataBySeries: HighchartDataBySeries = Object.assign(
    {},
    ...columnDefinitionsWithAxisIndex.map(
      ({ columnName, unit, isUnitPercentage, title, yAxisIndex }, i) => {
        const columnIndexInData = columnsExcludingTimestamp[i].index;
        return {
          [title]: {
            dataPoints: parsedRows
              // handle sparse data sets by filtering rows with no data for this index
              .filter((row) => !isNaN(row[columnIndexInData]))
              .map((row) => [row[0], row[columnIndexInData]]),
            yAxisIndex: yAxisIndex,
            tooltip: columnName,
          },
        };
      }
    )
  );

  return getHighchartOptions(
    {
      title: derivedTitle,
      dataBySeries: dataBySeries,
      plotLines: plotLines,
      yAxis: yAxis,
    },
    onComplete
  );
};

export const deriveAxisFromColumnDefinitions = <T>(
  columnDefinitions: ({
    unit: string | undefined;
    isUnitPercentage: boolean;
  } & T)[]
) => {
  const dummySeries = [
    { columnName: "", unit: "", isUnitPercentage: false, title: "Events Only" },
  ];
  const distinctAxis =
    columnDefinitions.length === 0
      ? groupByFunc(dummySeries, (x) => x.unit || "")
      : groupByFunc(columnDefinitions, (x) => x.unit || "");

  // const distinctAxis = groupByFunc(columnDefinitions, (x) => x.unit || "")

  return {
    yAxis: Object.keys(distinctAxis)
      // isUnitPercentage is derived from unit, so we can just look that up
      .map((unitName) => ({
        name: unitName || "(unitless)",
        isPercentage: distinctAxis[unitName][0].isUnitPercentage,
      })),

    columnDefinitionsWithAxisIndex: columnDefinitions.map((x) => ({
      ...x,
      yAxisIndex: Object.keys(distinctAxis).indexOf(x.unit || ""),
    })),
  };
};
